export const COLUMN_SEARCH_TYPES = {
  EMAIL: 'email',
  TEXT: 'text',
  NUMBER: 'number',
  NAME: 'name',
} as const;

export const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'] as const;

export const CORRESPONDENT_STATUS_OPTIONS = ['Activo', 'Registrado', 'Cierre temporal', 'Cierre definitivo'] as const;

export const SUBSIDIARY_STATUS_OPTIONS = [
  'Registrado',
  'Activo',
  'Cierre Temporal Corresponsal',
  'Cierre Temporal Sucursal',
  'Cierre Definitivo',
] as const;

export const NOTIFICATION_TYPE = {
  EMAIL: 'email',
  SMS: 'sms',
} as const;

export const ERROR_LIST_IMPORT_SUBSIDIARIES = {
  0: 'El campo nombre es requerido',
  1: 'El campo calle es requerido',
  2: 'El campo asfi code es requerido',
  3: 'El campo lat es requerido',
  4: 'El campo lng es requerido',
  5: 'El campo fecha es requerido',
} as const;
